module.exports = __webpack_public_path__ + "static/media/addFavor.12c540ef.svg";